import React from 'react'
import { Button } from "@material-ui/core"
import { joinAttributes } from 'tools/formatters'
import strings from 'strings'
import StatusIndicator from 'components/shared/StatusIndicator/index'

const RelatedBusinessCard = (props) => {

    const { business, actionToPerform, actionText, relationType, actionLoading, isQuickSearch } = props

    const address = joinAttributes({
        street: business?.physicalAddressStreet,
        city: business?.physicalAddressCity,
        state: business?.physicalAddressState,
        zip: business?.physicalAddressZip
    })

    const color = business?.normalizedStatus === 'Active' ? 'green' : 'gray'

    // Determine label based on relationship type
    const getLabelDisplay = () => {
        if (relationType === 'byAgent') {
            return <div className='blueLabel mr-2'> {strings.APPLICANT?.SOS?.RELATED_BY_AGENT} </div>
        }
        if (relationType === 'byOfficer') {
            return <div className='redLabel mr-2'> {strings.APPLICANT?.SOS?.RELATED_BY_OFFICER} </div>
        }
        return <div className='yellowLabel mr-2'> Related </div>
    }

    return (
        <>
            <hr></hr>
            <div className='d-flex justify-content-between mb-3 mt-3'>
                <div className='flex-fill'>
                    <div className='d-flex align-items-center'>
                        <p className='possibleAlternativeTitle mb-0 mr-3'>{business?.title}</p>
                        {business?.normalizedStatus && <StatusIndicator color={color} text={business?.normalizedStatus} side='left' />}
                    </div>
                    <p className='mb-0 mt-2'>{address}</p>
                    {business?.agentName && (
                        <p className='mb-0 mt-2'>
                            <span className='font-weight-bold'>Agent: </span>
                            {business?.agentName}
                        </p>
                    )}
                    {business?.officers?.length > 0 && (
                        <div className='mb-0 mt-2' style={{ maxHeight: '150px', overflowY: 'auto' }}>
                            <p className='font-weight-bold mb-2'>Officers:</p>
                            {business?.officers.map((officer, idx) => (
                                <p key={idx} className='mb-1'>
                                    {officer?.name} ({officer?.title})
                                </p>
                            ))}
                        </div>
                    )}
                </div>
                <div className='d-flex align-items-center'>
                    {getLabelDisplay()}
                    <Button
                        variant="outlined"
                        color='primary'
                        onClick={() => actionToPerform(business)}
                        className={`search-for-related-${isQuickSearch ? 'qs' : 'app'}`}
                        disabled={actionLoading || !business?.sosId}
                    >
                        {actionText}
                    </Button>
                </div>
            </div>
        </>
    )
}

export default RelatedBusinessCard